import React, { createContext, useCallback } from 'react';
import { useMemo } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';

export const ResponsiveSize = {
    small: 900,
    medium: 901
};

const ResponsiveContext = createContext();

export const ResponsiveContextProvider = ({ children }) => {

    const [innerWidth, setInnerWidth] = useState(window.innerWidth);
    const [navBarMaxItems, setNavBarMaxItems] = useState(ResponsiveSize.medium);
    const [responsiveSize, setResponsiveSize] = useState(ResponsiveSize.medium);

    const onResize = useCallback(() => {
        let responsiveSize = ResponsiveSize.small;
        if (window.innerWidth > ResponsiveSize.small) responsiveSize = ResponsiveSize.medium;
        setResponsiveSize(responsiveSize);

        let navBarMaxItems = 0;
        let remaining = window.innerWidth - 240 - 360 - 120; // Largeur moins logo moins user menu moins dropdown
        while (remaining > 0) {
            if (navBarMaxItems > 0) remaining -= 120;  // Ecart entre chaque item
            remaining -= 240; // Largeur d'un item
            if (remaining >= 0) navBarMaxItems++;
        }
        setNavBarMaxItems(navBarMaxItems);
        setInnerWidth(window.innerWidth);
    }, []);

    useEffect(() => {
        onResize();
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, [onResize]);

    const value = useMemo(
        () => ({ innerWidth, navBarMaxItems, responsiveSize }),
        [innerWidth, navBarMaxItems, responsiveSize]
    );

    return <ResponsiveContext.Provider value={value}>
        {children}
    </ResponsiveContext.Provider>;

};

export const useResponsiveSize = () => {
    const data = React.useContext(ResponsiveContext);
    if (data === undefined) throw new Error();
    const { innerWidth, navBarMaxItems, responsiveSize } = data;
    return { innerWidth, navBarMaxItems, responsiveSize };
};